import { ActivityIndicator } from "react-native";
import { StyleSheet } from "react-native-unistyles";
import { Button } from "@visioni/a3s-ui/components";
import { Text, View } from "@src/components";
import { TenantLink, useTenantId } from "@src/features/tenants";

/** The report email page's non-form states. */

export function ReportEmailDeliveryLoading() {
  return (
    <View padding="3xl" alignItems="center">
      <ActivityIndicator />
    </View>
  );
}

export function ReportEmailDeliveryNotFound() {
  return (
    <View gap="lg" alignItems="center">
      <Message
        title="Site not found"
        body="This site doesn't exist, or isn't one of your organisation's. Pick a site from the RoadSense list to continue."
      />
      <RoadSenseListLink />
    </View>
  );
}

export function ReportEmailDeliveryForbidden() {
  return (
    <Message
      title="You don't have access to these report emails"
      body="Ask an administrator of your organisation for access."
    />
  );
}

export function ReportEmailDeliveryLoadFailed({ onRetry }: { readonly onRetry: () => void }) {
  return (
    <View gap="lg" alignItems="center">
      <Message title="Couldn't load your report emails" body="Something went wrong. Please try again." />
      <Button variant="secondary" label="Try again" onPress={onRetry} />
    </View>
  );
}

/** RoadSense, like these pages, is web only. */
export function ReportEmailDeliveryWebOnly() {
  return (
    <View flex={1} alignItems="center" justifyContent="center" padding="3xl" gap="md">
      <Text textStyle="sm/semibold" color="text" textAlign="center">
        RoadSense reports are only available on the web client.
      </Text>
      <Text textStyle="xs/regular" color="textMuted" textAlign="center">
        Open this page in your browser to manage your report emails.
      </Text>
    </View>
  );
}

function RoadSenseListLink() {
  const tenantId = useTenantId();
  return (
    <TenantLink href={{ pathname: "/tenants/[tenantId]/reports/roadsense", params: { tenantId } }}>
      <Text textStyle="xs/semibold" color="text" style={styles.link}>
        Go to RoadSense sites
      </Text>
    </TenantLink>
  );
}

function Message({ title, body }: { readonly title: string; readonly body: string }) {
  return (
    <View padding="3xl" alignItems="center" gap="sm">
      <Text textStyle="sm/semibold" color="text" textAlign="center">
        {title}
      </Text>
      <Text textStyle="xs/regular" color="textMuted" textAlign="center">
        {body}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create(() => ({
  link: {
    textDecorationLine: "underline",
  },
}));
